import React from "react";
import { FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const FundApprovePopup = ({ className = "", children, onClose, visible, title }) => {
  // Modernized animation: A subtle slide + scale fade instead of a full screen drop-in
  const dropIn = {
    hidden: {
      y: -20,
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.2,
        type: "spring",
        damping: 25,
        stiffness: 300,
      },
    },
    exit: {
      y: 20,
      opacity: 0,
      scale: 0.95,
      transition: { duration: 0.15, ease: "easeIn" },
    },
  };

  return (
    // Assuming you have an AnimatePresence wrapping this in the parent, 
    // or Backdrop handles unmounting.
    <Backdrop visible={visible} onClick={onClose}>
      <motion.div
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        exit="exit"
        variants={dropIn}
        // Swapped basic shadow for shadow-2xl, added perfectly centered flex positioning, 
        // and rounded-2xl for a smoother, modern card look.
        className={`bg-white z-50 shadow-2xl rounded-2xl w-[calc(100%-2rem)] max-w-lg fixed inset-0 flex m-auto flex-col ${className}`}
        onClick={(e) => e.stopPropagation()} // Prevents clicks inside the modal from closing it
      >
        {/* Modern Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800">{title}</h2>
          <button
            type="button"
            className="text-gray-400 hover:text-gray-700 hover:bg-gray-100 p-2 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-gray-200"
            onClick={onClose}
            aria-label="Close modal"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
        
        {/* Children Container - Removed the tight p-1 margin so the child component dictates spacing */}
        <div>
          {children}
        </div>
      </motion.div>
    </Backdrop>
  );
};

export default FundApprovePopup;




const Backdrop = ({ children, onClick , visible}) => {

  if (!visible) {
    return null
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      onClick={onClick}
      className="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/40 backdrop-blur-md"
    >
      {children}
    </motion.div>
  );
};

